// extracted by mini-css-extract-plugin
export default {"icon":"Navigation_icon__lPT0N","active":"Navigation_active__8X7xS"};